import React from 'react';
import DataTable from '../../smart-kit/data-table/DataTable';
import { SimpleCard } from 'app/components';
import Api, { apiPaths } from 'app/services/api';
import { Avatar } from '@mui/material';

const Customers = () => {
  const columns = [
    {
      name: 'Name',
      key: 'last_name',
      render: (record, i) => (
        <div className="flex items-center">
          <Avatar className="list-avatar" sizes="" src={Api.getPhotoUrl(record.profile_pic)} />
          <h5 className="mr-3 text-15">{`${record.first_name} ${record.last_name}`}</h5>
        </div>
      )
    },
    { name: 'Mobile', key: 'mobile_number' }
    // { name: 'Company', key: 'company_name' },
    // { name: 'Seller', key: 'seller_name' },
    // { name: 'Needs Followup', key: 'followup_reason', render: (record) => (
    //   <div className={clsx("text-15", record.followup_reason && 'text-error')}>
    //     {record.followup_reason ? record.followup_reason.replaceAll('_', ' ') : ''}
    //   </div>
    // )}
    // { name: 'Create Date', key: 'created_at', render: (record, i) => (<div>{new Date(record.created_at).toLocaleDateString()}</div>), sort: true },
  ];

  const filtersOn = [
    { name: 'Mobile', key: 'mobile_number' }
    // { name: 'Name', key: 'name' },
    // { name: 'Company', key: 'company_name' },
    // { name: 'Needs Followup', key: 'needs_followup_bool', type: 'switch' }
  ];

  return (
    <div className="m-sm-30">
      <div className="py-3" />
      <SimpleCard>
        <DataTable
          title="Customers"
          apipath={apiPaths.CUSTOMERS}
          columns={columns}
          filtersOn={filtersOn}
          hideActions={['delete', 'view', 'create']}
        />
      </SimpleCard>
    </div>
  );
};

export default Customers;
